import React, { useState, createContext } from "react";
//import addons from "react-addons/index";
import { Row, Col, Container, Card } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import { ProtectedRoute } from "../../ProtectedRoute";
import AccountBalance from "./Components/AccountBalance";
import loginStore from "../../flux/stores/loginStore";

//var classSet = React.classSet;


export default function ViewAccountBalance() {
   
      let memberId = loginStore.getMemberId();
      return (
      
      <ProtectedRoute>
      <Container className="main-content-container px-4 pb-3">
        <Row noGutters className="page-header py-4">
      <PageTitle
        sm="4"
        title="Customer NSF"
        className="text-sm-left"
      />
      </Row>
      <Row noGutters className="px-0">
            <Col>
        
            <AccountBalance memberId={memberId}/> 
          
          </Col>
      </Row>
      
        
      
      </Container>
      </ProtectedRoute>
    );
    
    }

